import { debounce } from 'lodash';
import React, { Component } from 'react';
import Util from '../../../../util/UtilClass';
import TemporaryTableQrRepository from '../../../repository/TemporaryTableQrRepository';
import './TableActiveTimeList.scss'
import { InfinityIcon } from '../../../../app/Merchant/InventoryModule/Icon/Icon';

class OrderTime {
    tableName = ""
    elapsed = 0
    tableSession = null
    tempTableQr = null
    color = null
    duration = null
    table = null
}
class TableActiveTimeList extends Component {
    constructor(props) {
        super(props)

        const tableSessions = this.getTableSessions()
        this.state = {
            tableSessions: tableSessions,
            tempTableQrs: [],
            orderTimes: [],
        }

        this.callbackKey = "TableActiveTimeList"
    }

    componentDidMount() {
        this.debounceSetState({
            orderTimes: this.getOrderTimes(this.state.tableSessions)
        })
        TemporaryTableQrRepository.getInstance().loadAll((tempTableQrs) => {
            this.debounceSetState({
                tempTableQrs,
                orderTimes: this.getOrderTimes(this.state.tableSessions),
            })
        }, this.callbackKey, this)

        this.startTimer()
    }

    componentWillUnmount() {
        this.stopTimer()
        this.debounceSetState.cancel()
        TemporaryTableQrRepository.getInstance().removeCallback(null, this)
    }

    startTimer = () => {
        this.timer = setInterval(() => {
            this.calculateElapsedTime(this.state.orderTimes)
            this.forceUpdate()
        }, 1000)
    }
    stopTimer = () => {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }

    debounceSetState = debounce((newState, callback) => {
        this.setState(newState, callback)
    }, 100)

    componentDidUpdate(prevProps, prevState) {
        this.handleUpdateOrderTime(prevProps, prevState)
    }

    handleUpdateOrderTime = (prevProps, prevState) => {
        let isNeedUpdateState = false
        const propsChangeCheck = [
            "tables", "tableSessionWithActiveOrdersArr"
        ]
        const stateChangeCheck = [
            "tempTableQrs"
        ]

        for (let i = 0; i < propsChangeCheck.length; i++) {
            if (prevProps[propsChangeCheck[i]] !== this.props[propsChangeCheck[i]]) {
                isNeedUpdateState = true
                break
            }
        }
        if (!isNeedUpdateState) {
            for (let i = 0; i < stateChangeCheck.length; i++) {
                if (prevState[stateChangeCheck[i]] !== this.state[stateChangeCheck[i]]) {
                    isNeedUpdateState = true
                    break
                }
            }
        }
        if (isNeedUpdateState) {
            this.updateOrderTimes()
        }
    }

    updateOrderTimes = debounce(() => {
        let tableSessions = this.getTableSessions()
        let orderTimes = this.getOrderTimes(tableSessions)
        this.setState({
            tableSessions, orderTimes
        })
    }, 100)

    getOrderTimes = (tableSessions) => {
        let orderTimes = []
        tableSessions.forEach(tableSession => {
            const table = (this.props.tables || []).find(t => t.id == tableSession.table_id) || {}
            const tempTableQr = this.state.tempTableQrs.find(ttqr => ttqr.table_session_id == tableSession.id)
            let orderTime = new OrderTime()
            orderTime.tableSession = tableSession
            orderTime.tempTableQr = tempTableQr
            orderTime.table = table
            orderTimes.push(orderTime)
        })
        this.calculateElapsedTime(orderTimes)
        orderTimes.sort((a, b) => {
            return b.elapsedMinute - a.elapsedMinute
        })
        return orderTimes
    }
    calculateElapsedTime = (orderTimes) => {
        orderTimes.forEach(orderTime => {
            const { elapsedSecond, elapsedMinute, hms, } = Util.calculateElapsedTime(moment(orderTime.tableSession.created_at))
            orderTime.elapsed = hms
            orderTime.elapsedMinute = elapsedMinute
            orderTime.duration = parseInt(orderTime.tempTableQr && orderTime.tempTableQr.duration || 0)
            orderTime.color = orderTime.tempTableQrs && orderTime.tempTableQrs.color || ""
        })
    }

    getTableSessions = () => {
        const tableIds = this.props.tables.map(t => parseInt(t.id))
        let tableSessionWithActiveOrders = this.props.app.state.tableSessionWithActiveOrdersArr.filter(s => tableIds.indexOf(parseInt(s.table_id)) != -1)
        return tableSessionWithActiveOrders
    }

    debugInfo = (orderTime) => {
        const debugMode = window.debugSetting && window.debugSetting.active_time_list && window.debugSetting.active_time_list.debug_mode
        return debugMode && <div>
            <div>
                {orderTime.tableSession ? <span>{orderTime.tableSession.id}: {orderTime.tableSession.created_at}</span> : ""}
            </div>
            <div>
            {orderTime.tempTableQr ? `TempQr ID: ${orderTime.tempTableQr.id}`: ""}
            </div>
        </div>
    }
    render() {
        return (
            <div className="table-active-time-list-container">
                <table id="table-active-time-list-table">
                    <tbody>
                        {
                            this.state.orderTimes.map(orderTime => {
                                let btnText = <span className="hms-time">{orderTime.elapsed} / <InfinityIcon /></span>
                                if (orderTime.duration) {
                                    btnText = <span className="hms-time">{orderTime.elapsed} / {Util.durationToHms(orderTime.duration, 'minute')}</span>
                                }
                                let colorClass = ""
                                return <tr key={orderTime.tableSession.id} className={colorClass}>
                                    <td>
                                        {lang.table} {orderTime.table.name}
                                    </td>
                                    <td>
                                        <button className="table-active-time-indicator btn btn-default">
                                            {btnText}
                                            {this.debugInfo(orderTime)}
                                        </button>
                                    </td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default TableActiveTimeList;